const palette = {
  // transparent
  placeholder: '#26282d88',
  transparent: '#FFFFFF00',

  // white black
  white: '#FFFFFF',
  pureBlack: '#000000',

  // social
  gold: '#FFD571',
  facebook: '#365899',
  pinterest: '#CE1D1F',
  reddit: '#FF4500',

  // primary
  orange: '#F16434',
  orange70: '#F59271',
  orange50: '#F8B199',
  orange30: '#FBD0C2',
  orange20: '#FCE0D6',
  orange10: '#FEEFEB',

  // dark gray
  darkGray: '#202020',
  darkGray70: '#636363',
  darkGray50: '#8F8F8F',
  darkGray30: '#BCBCBC',
  darkGray20: '#D2D2D2',
  darkGray10: '#E9E9E9',

  // gray
  gray: '#A3B0B3',
  gray70: '#BFC8CA',
  gray50: '#D1D7D9',
  gray30: '#E3E7E8',
  gray20: '#EDEFF0',
  gray10: '#F6F7F7',

  // lightGray
  lightGray: '#D1D7D9',
  lightGray70: '#DFE3E4',
  lightGray50: '#E8EBEC',
  lightGray30: '#F1F3F4',
  lightGray20: '#F6F7F7',
  lightGray10: '#FAFBFB',

  // blue
  blue: '#4285F4',
  blue70: '#7BAAF7',
  blue50: '#A0C2F9',
  blue30: '#C6DAFC',
  blue20: '#D9E7FD',
  blue10: '#ECF3FE',

  // Neutrals
  neutral01: '#26282D',
  neutral02: '#43464B',
  neutral03: '#858B98',
  neutral04: '#C7CCD1',
  neutral05: '#E8EBED',
  neutral06: '#F5F6F7',

  // Accents
  accents01: '#F16232',
  accents02: '#FF5E29',

  raisinBlack70: '#67696B',

  // graph & charts
  darkRed: '#E53435',
  red: '#FE8485',
  lightRed: '#EE8A88',
  dullRed: '#F2A7A6',

  darkGreen: '#00A862',
  green: '#85ECC1',
  lightGreen: '#E0FAEF',
  dullGreen: '#C0ECD9',

  darkYellow: '#E89900',
  yellow: '#F8BC54',
  limeYellow: '#F4E26C',
  dullYellow: '#FFEAC5',

  brightOrange: '#FFAD7E',
  dullOrange: '#F3AF86',
  lightOrange: '#F5C299',

  darkBlue: '#1A0DAB',
  deepBlue: '#296AE1',
  lightBlue: '#86B7EC',
  dimBlue: '#FBFCFE',
  magentaBlue: '#BBB6FF',

  lightPink: '#FFEFEA',
  pink: '#FDB1FF',

  // status colors
  success: '#85ECC1',
  danger: '#FE8485',
  warning: '#F8BC54',
  good: '#FFAD7E',
  info: '#71DEEF',

  primaryTint: '#939395',
  secondaryTint: '#9D9DA0',
}

const shadows = {
  shadowA: '0px 10px 32px 0px rgba(32, 32, 32, 0.08)',
  shadowB: '-6px 10px 32px 0px rgba(32, 32, 32, 0.08)',
  shadowC: '0px 4px 8px 0px rgba(0, 0, 0, 0.24)',
  shadowD: '0px 3px 7px 0px rgba(0, 0, 0, 0.15)',
  shadowE: '1px -1px 3px 0px rgba(163, 176, 179, 0.5)',
  shadowF: '0px 2px 4px rgba(0, 0, 0, 0.02), 0px 10px 20px rgba(0, 0, 0, 0.08)',
  shadowG: '0px 3px 5px rgba(0, 0, 0, 0.12)',
  shadowH:
    '0px 4px 26px 0px rgba(0, 0, 0, 0.04), 0px 4px 100px 0px rgba(0, 0, 0, 0.06)',
  shadowI: '0px 4px 10px 0px rgba(0, 0, 0, 0.07)',
}

const sizes = {
  buttonUnit: '39px',
  contentSeparation: '32px',
}

const spacings = {
  s4: '4px',
  s8: '8px',
  s12: '12px',
  s16: '16px',
  s24: '24px',
  s32: '32px',
  s40: '40px',
  s48: '48px',
  s64: '64px',
}

const paddings = {
  p16: '16px',
  p24: '24px',
  p32: '32px',
  p40: '40px',
  p48: '48px',
  p56: '56px',
  p64: '64px',
}

const mediaQueries = {
  minMobile: '@media only screen and (max-width: 360px)',
  smallMobile: '@media only screen and (max-width: 540px)',
  mobile: '@media only screen and (max-width: 767px)',
  tablet: '@media only screen and (max-width: 950px)',
  laptop: '@media only screen and (max-width: 1024px)',
  smallDesktop: '@media only screen and (max-width: 1280px)',
  desktop: '@media only screen and (max-width: 1440px)',
  bigDesktop: '@media only screen and (min-width: 1440px)',
  notMobile: '@media only screen and (min-width: 768px)',
}

const fonts = {
  primary: 'geomanistregular',
  primaryLight: 'geomanistlight',
  primaryBook: 'geomanistbook',
  primaryBold: 'geomanistbold',
  primaryMedium: 'geomanistmedium',
  shadowsintolight: 'shadowsintolightregular',
}

const setOpacity = (hex, alpha) =>
  `${hex}${Math.floor(alpha * 255)
    .toString(16)
    .padStart(2, 0)}`

const hexToRGB = (h) => {
  let r = 0
  let g = 0
  let b = 0

  // 3 digits
  if (h.length === 4) {
    r = `0x${h[1]}${h[1]}`
    g = `0x${h[2]}${h[2]}`
    b = `0x${h[3]}${h[3]}`

    // 6 digits
  } else if (h.length === 7) {
    r = `0x${h[1]}${h[2]}`
    g = `0x${h[3]}${h[4]}`
    b = `0x${h[5]}${h[6]}`
  }

  return `rgb(${+r}, ${+g}, ${+b})`
}

export {
  palette,
  sizes,
  mediaQueries,
  fonts,
  shadows,
  spacings,
  paddings,
  setOpacity,
  hexToRGB,
}
